import React from 'react'
import {Link} from 'gatsby'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import Container from './container'

export default function WorkSubHeading({headingText}) {
  return (
    <StyledComponent>
      <Container>
        <Fade>
          <h2>{headingText}</h2>
        </Fade>
      </Container>
    </StyledComponent>
  )
}

const StyledComponent = styled.div`
  padding-top: 4rem;

  @media (min-width: 1200px) {
    padding-top: 11rem;
  }

  h2 {
    font-size: 2.5rem;
    font-weight: 100;
  }
`
